/**
 * Tag Size Styles
 * Size configurations for ActionTypeTag and meeting type tag components.
 * Uses explicit pixel values for precise control over these compact badge components.
 *
 * Scale: SM (28px) → MD (+4px = 32px) → LG (+4px = 36px)
 */

export type TagSize = "sm" | "md" | "lg";

interface IconBadgeSizeStyle {
  w: string;
  h: string;
  p: string;
  iconSize: string;
  borderRadius: string;
}

interface PillBadgeSizeStyle {
  h: string;
  px: string;
  py: string;
  spacing: string;
  iconSize: string;
  fontSize: string;
  lineHeight: string;
  borderRadius: string;
}

export const ICON_BADGE_SIZE_STYLES: Record<TagSize, IconBadgeSizeStyle> = {
  sm: {
    w: "28px",
    h: "28px",
    p: "8px",
    iconSize: "12px",
    borderRadius: "4px",
  },
  md: {
    w: "32px",
    h: "32px",
    p: "8px",
    iconSize: "16px",
    borderRadius: "4px",
  },
  lg: {
    w: "36px",
    h: "36px",
    p: "8px",
    iconSize: "20px",
    borderRadius: "4px",
  },
};

export const PILL_BADGE_SIZE_STYLES: Record<TagSize, PillBadgeSizeStyle> = {
  sm: {
    h: "28px",
    px: "4px",
    py: "8px",
    spacing: "4px",
    iconSize: "12px",
    fontSize: "10px",
    lineHeight: "15px",
    borderRadius: "4px",
  },
  md: {
    h: "32px",
    px: "6px",
    py: "8px",
    spacing: "4px",
    iconSize: "16px",
    fontSize: "12px",
    lineHeight: "18px",
    borderRadius: "4px",
  },
  lg: {
    h: "36px",
    px: "8px",
    py: "8px",
    spacing: "4px",
    iconSize: "20px",
    fontSize: "14px",
    lineHeight: "21px",
    borderRadius: "4px",
  },
};
